import React from 'react';
import {  Tooltip } from "@mui/material"

const Icon = (props) => {

  const renderIcon = () => {
    if(props.label){
      if (props.label === 'Low') {
        return  (<svg width="12" height="12" className={props.className} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6.5L10.9425 5.4425L6.75 9.6275L6.75 0.5L5.25 0.499999L5.25 9.6275L1.065 5.435L5.24537e-07 6.5L6 12.5L12 6.5Z" fill={props.IconColor  ? props.IconColor : '#c1c1c1'}/>
        </svg>);
      } else if (props.label === 'High') {
        return (<svg width="12" className={props.className} height="12" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 6.5L1.0575 7.5575L5.25 3.3725V12.5H6.75V3.3725L10.935 7.565L12 6.5L6 0.5L0 6.5Z" fill={props.IconColor  ? props.IconColor : '#c1c1c1'}/>
        </svg>
        );
      }else if (props.label === 'Highest') {
        return (<svg width="12" className={props.className} height="12" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 6.5L1.0575 7.5575L5.25 3.3725V12.5H6.75V3.3725L10.935 7.565L12 6.5L6 0.5L0 6.5Z" fill={props.IconColor  ? props.IconColor : '#c1c1c1'}/>
        </svg>
        );
      }  
      else {
        return (<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="12" height="12" viewBox="0 0 16 16" fill="none">
        <path d="M2 12V9.6H14V12H2ZM2 6.4V4H14V6.4H2Z" fill={props.IconColor  ? props.IconColor : '#c1c1c1'} />
      </svg>
        );
      }
    }
    return ''
  };

  return (
    <Tooltip title={props.label}>
      {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M2 12V9.6H14V12H2ZM2 6.4V4H14V6.4H2Z" fill={props.IconColor  ? props.IconColor : '#c1c1c1'} />
      </svg> */}
      {renderIcon()}
    </Tooltip>
  );
};

export default Icon;